import { BelpostAddressType } from '$shared/types/belpost-republic-address';

export class OldAddress {
  public id: number;
  public comment: string;
  public type: string;
  public is_default = false;
  public postcode: string;
  public region: string;
  public district: string;
  public city_type: string;
  public city: string;
  public street_type: string;
  public street: string;
  public house: string;
  public housing?: string;
  public apartment?: string;
  public name: string;
  public building?: any;
  public flat: string;
  public address: string;
  public address_type: BelpostAddressType;
  public cell_number: string;
  public created_at: string;
  public updated_at: string;
  public postcode_id?: number;
  public first_name: string;
  public second_name: string;
  public last_name: string;

  constructor(item?) {
    this.update(item);
  }

  public update(el): void {
    if (el) {
      Object.assign(this, el);
    }
  }
}
